import axios from "axios";
import {
  UNAUTHENTICATED_ERROR_EVENT,
  UNAUTHORIZED_ERROR_EVENT,
} from "./constants";
import { v4 as uuidv4 } from "uuid";
import { APIendpoints } from "../utils/constants/APIendpoints";

export const axiosInterceptor = () => {
  axios.interceptors.request.use(
    function (config) {
      config.headers["X-Trackingid"] = `${uuidv4()}`;
      config.headers["x-client"] = "seller";
      config.headers["Authorization"] = window.localStorage.getItem("token");
      const routingContext = window.localStorage.getItem("routingContext")
      if (routingContext !== "") {
        config.headers["routing_context"] = routingContext;
      }

      const appType = window.localStorage.getItem("apptype");
      if (appType) {
        config.headers["apptype"] = appType;
      }

      return config;
    },
    function (error) {
      const isS3Url =
        error.config &&
        /(s3-|s3\.)?(.*)\.amazonaws\.com/.test(error.config.url);
      if (!isS3Url && [401, 410].includes(error?.response?.status)) {
        alert("Session Expired! Please login again");

        window.localStorage.removeItem("token");
        window.localStorage.removeItem("outletId");
        window.localStorage.removeItem("outletName");
        if (window && window.logoutChannelMessageHandler) {
          window.logoutChannelMessageHandler.postMessage("true");
        }
      }

      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const isTrackingEndpoint = error.config?.url?.includes(APIendpoints.sendSellerAppTracking);

      if ([401, 410].includes(error?.response?.status)) {
        if (isTrackingEndpoint) {
          return Promise.reject(error);
        }
        document.dispatchEvent(new CustomEvent(UNAUTHENTICATED_ERROR_EVENT));
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("outletId");
        window.localStorage.removeItem("outletName");
        if (window && window.logoutChannelMessageHandler) {
          window.logoutChannelMessageHandler.postMessage("true");
        }
        // replace() navigates away cleanly; reload() re-runs API calls before auth is set up → 401 loop.
        const redirect = encodeURIComponent(window.location.pathname);
        window.location.replace(`/login?redirect=${redirect}`);
      } else if (error?.response?.status === 403) {
        document.dispatchEvent(new CustomEvent(UNAUTHORIZED_ERROR_EVENT));
      }
      return Promise.reject(error);
    }
  );
};
